import { useFormContext } from 'react-hook-form';
import { RecurringRuleFormValues } from '../RecurringRulesForm';

const useRecurringRuleFormContext = () => {
  return useFormContext<RecurringRuleFormValues>();
};

export default useRecurringRuleFormContext;
